import { render, staticRenderFns } from "./labels_select_root.vue?vue&type=template&id=71e16415"
import script from "./labels_select_root.vue?vue&type=script&lang=js"
export * from "./labels_select_root.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports